import { render } from "./competitors-tab.vue?vue&type=template&id=9b6753de&scoped=true"
import script from "./competitors-tab.vue?vue&type=script&lang=js"
export * from "./competitors-tab.vue?vue&type=script&lang=js"

import "./competitors-tab.vue?vue&type=style&index=0&id=9b6753de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b6753de"]])

export default __exports__